//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SourceBase from '../source-common-module/source-base';
import SourceMaterial from '../source-common-module/source-material';
import SourceSup from '../source-common-module/source-sup';
import SourceOffer from '../source-common-module/source-offer';
import SourceBusiness from '../source-common-module/source-business';
import SourceAttach from '../source-common-module/source-attach';
import SourceNotice from '../source-common-module/source-notice';
import SourceQuestion from '../source-common-module/source-question';
export default {
  name: "source-item-approval",
  components:{
    SourceBase,
    SourceMaterial,
    SourceSup,
    SourceOffer,
    SourceBusiness,
    SourceAttach,
    SourceNotice,
    SourceQuestion
  },
  props:['dataId'],
  data(){
    return{
      sourceId: null,
      sourceDto:{},
      selectModel:'base',
      defaultPar:{},
      priceTemplateList:[],
      rotation:{}
    }
  },
  methods:{
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
          this.sourceDto.sourceRotationList = this.sourceDto.sourceRotationList.sort((a,b) => a.round - b.round);
          this.priceTemplateList = (this.sourceDto.priceTemplete && this.sourceDto.priceTemplete.sptQuoteFieldList) || [];
          this.priceTemplateList.sort((a, b) => a.sort - b.sort);
          this.rotation = this.sourceDto.sourceRotationList[this.sourceDto.currentRound-1];
          this.getDefault();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getDefault(){
      if(this.sourceDto.sourceType){
        this.$loadingShow();
        this.$get(`api/sourceType/${this.sourceDto.sourceType.id}`).then((res) => {
          for(let k in res){
            if(res[k] && res[k].defaultValue){
              if(res[k].defaultValue === 'true'){
                res[k].defaultValue = true;
              }else if(res[k].defaultValue === 'false'){
                res[k].defaultValue = false;
              }
            }
          }
          this.defaultPar = res;
          this.copyTemplateToDefaultPar();
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    copyTemplateToDefaultPar(){
      this.defaultPar.materialType = this.sourceDto.priceTemplete.materialType;
      this.defaultPar.demandQuantity = this.sourceDto.priceTemplete.demandQuantity;
      this.defaultPar.baseUnit = this.sourceDto.priceTemplete.baseUnit;
      this.defaultPar.matPlant = this.sourceDto.priceTemplete.matPlant;
      this.defaultPar.matDemandDate = this.sourceDto.priceTemplete.matDemandDate;
      this.defaultPar.matPurchaseNum = this.sourceDto.priceTemplete.matPurchaseNum;
      this.defaultPar.matRemark = this.sourceDto.priceTemplete.matRemark;
      this.defaultPar.matAttach = this.sourceDto.priceTemplete.matAttach;
    },
    changeShowModel(str){
      this.selectModel = str;
      if(str !== 'flow'){
        this.$emit('changeFlowInfo',false);
      }else{
        this.$emit('changeFlowInfo',true);
      }
    },
    valid(){
      return true;
    },
    formData(){
      return this.sourceDto;
    }
  },
  mounted(){
    this.sourceId = this.dataId;
    this.getSourceDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-item/source-item-approval.vue